import React, { useCallback, useReducer } from 'react';

import { AgendaSidePanelContext, AgendaSidePanelInitialState } from '.';
import { AGENDA_SIDEPANEL_ACTIONS } from './actions';
import AgendaSidePanelContextReducer from './reducer';

export const AgendaSidePanelContextProvider = ({ children }) => {
  const [AgendaSidePanelState, AgendaSidePanelDispatch] = useReducer(
    AgendaSidePanelContextReducer,
    AgendaSidePanelInitialState
  );

  const openAgendaSidePanel = useCallback(
    ({ agendaId, agendaText, checkInInstanceId, checkInParentId, filterEmpIds }) => {
      AgendaSidePanelDispatch({
        type: AGENDA_SIDEPANEL_ACTIONS.OPEN_SIDEPANEL,
        payload: {
          agendaId,
          agendaText,
          // following are used for action Items
          checkInInstanceId,
          checkInParentId,
          filterEmpIds,
        },
      });
    },
    []
  );

  const closeAgendaSidePanel = useCallback(() => {
    AgendaSidePanelDispatch({
      type: AGENDA_SIDEPANEL_ACTIONS.CLOSE_SIDEPANEL,
    });
  }, []);

  return (
    <AgendaSidePanelContext.Provider
      value={{
        state: AgendaSidePanelState,
        openAgendaSidePanel,
        closeAgendaSidePanel,
      }}
    >
      {children}
    </AgendaSidePanelContext.Provider>
  );
};
